import { type FC } from 'react';

import AgentChatLogoBackground from '@/assets/images/agent-chat-logo-background.svg';
import AgentChatLogoMarkAsset from '@/assets/images/agent-chat-logo-mark.svg';

import './agent-chat-logo.css';

interface AgentChatLogoProps {
  className?: string;
  /** Turns the mark, for wherever the agent is working. */
  spinning?: boolean;
}

export const AgentChatLogoMark: FC<AgentChatLogoProps> = ({ className = '' }) => (
  <span
    aria-hidden="true"
    className={`relative flex shrink-0 items-center justify-center ${className}`}
  >
    <img
      src={AgentChatLogoMarkAsset}
      alt=""
      data-agent-chat-logo-mark
      className="h-[59.54%] w-[55.42%]"
    />
  </span>
);

export const AgentChatLogo: FC<AgentChatLogoProps> = ({ className = '', spinning = false }) => (
  <span
    aria-hidden="true"
    className={`relative block shrink-0 ${spinning ? 'agent-chat-logo-spin ' : ''}${className}`}
  >
    <img src={AgentChatLogoBackground} alt="" className="absolute inset-0 size-full" />
    <AgentChatLogoMark className="absolute inset-0 size-full" />
  </span>
);
